export enum RouteNames {
  Landing = "Landing",
  NewOrder = "NewOrder",
  Faq = "Faq",
  Shop = "Shop",
  Orders = "Orders",
  CancelOrder = "CancelOrder",
  OrderDetail = "OrderDetail",
  OrderConfirmation = "OrderConfirmation",
  DevKitAssets = "DevKitAssets",
  VisualStudioAssets = "VisualStudioAssets",
  Rma = "Rma",
  RmaDetail = "RmaDetail",
  CreateRma = "CreateRma",
}
